import { IconChevronDown16, RoundButton } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ScrollButton.css';

type TProps = {
  onClick: () => void;
};

export const ScrollButton: React.FC<TProps> = ({ onClick }) => {
  return (
    <div className={styles['container']}>
      <RoundButton title="" icon={<IconChevronDown16 />} theme="fill_light" size="M" onClick={onClick} />
    </div>
  );
};
